import * as Yup from "yup"

// Regex
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
const zipRegExp = /^[0-9]{5}(?:-[0-9]{4})?$/

export const podFormSchema = (editMode = false) =>
  Yup.object().shape({
    podName: Yup.string().required().min(3).label("Pod name"),
    emailAddress: Yup.string()
      .email()
      .lowercase()
      .required()
      .label("Email address"),
    zipCode: Yup.string()
      .matches(zipRegExp, "ZIP Code is not valid")
      .label("ZIP Code"),
    term: Yup.string().required().label("Term"),
    schoolName: Yup.string().label("School name"),
    grade: Yup.string().label("Grade"),
    podSize: Yup.number().required().label("Pod Size"),
    county: Yup.string().required().label("County"),
    location: Yup.string().required().label("Pod location"),
    state: Yup.string().required().label("State"),
    city: Yup.string().required().label("City"),
    instructor: Yup.string().required().label("Instructor"),
    curriculum: Yup.string().required().label("Curriculum"),
    cost: Yup.number().min(0).label("Cost"),
    paymentCycle: Yup.string().required().label("Payment cycle"),
    safety: Yup.array(Yup.string().optional()).label("Safety requirements"),
    preferences: Yup.array(Yup.string().optional()).label("Preferences"),
    technology: Yup.array(Yup.string().optional()).label("Technology"),
    podSpirit: Yup.string().label("Pod spirit"),
    podSchedule: Yup.string().label("Pod schedule"),
    podCurriculum: Yup.string().label("Pod curriculum"),
    podCost: Yup.string().label("Pod cost"),
    podCommunication: Yup.string().label("Pod communication"),
    podParentInvolvement: Yup.string().label("Pod parent involvement"),
    podTechnology: Yup.string().label("Pod technology"),
    podConflict: Yup.string().label("Pod conflict"),
    podRules: Yup.string().label("Pod rules"),
    toc: editMode
      ? null
      : Yup.boolean().oneOf(
          [true],
          `Please accept the Terms of Use and Privacy Policy`
        ),
    safetyAndScam: editMode
      ? null
      : Yup.boolean().oneOf(
          [true],
          `Please accept the Safety and Scam guidelines`
        ),
  })

export const podApplicationSchema = podApplicants =>
  Yup.object().shape({
    application: Yup.string().label("Application"),
    name: Yup.string().label("Name"),
    facebook: Yup.string().label("Facebook"),
    linkedIn: Yup.string().label("LinkedIn"),
    instagram: Yup.string().label("Instagram"),
    phoneNumber: Yup.string()
      .required()
      .matches(phoneRegExp, "Please enter a valid phone number"),
    emailAddress: Yup.string()
      .email()
      .strict()
      .lowercase("Email must contain only lowercase letters")
      .required()
      .notOneOf(podApplicants, "Someone has already applied with that email")
      .label("Email"),
    toc: Yup.boolean().oneOf(
      [true],
      `Please accept the Terms of Use and Privacy Policy`
    ),
    safetyAndScam: Yup.boolean().oneOf(
      [true],
      `Please accept the Safety and Scam guidelines`
    ),
  })
